import React from 'react';
import axios from 'axios';
import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Bank(props) {
    const [inputField, setInputField] = useState({
        bank_name: '',
        acc_no: '',
        ifsc: '',
        acc_holder: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputField(prev => ({ ...prev, [name]: value }));
    };

    const fetchData = () => {
        fetch('https://wealthmcx.com/Rest5/user_details_api/' + localStorage.getItem('userid'))
            .then((response) => response.json())
            .then((data) => {
                setInputField({
                    bank_name: data.bank_name || '',
                    acc_holder: data.acc_holder || '',
                    ifsc: data.ifsc || '',
                    acc_no: data.acc_no || ''
                });
            });
    };

    useEffect(() => {
        fetchData();
    }, []);

    const formSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        const formData = new FormData();
        formData.append("bank_name", inputField.bank_name);
        formData.append("acc_no", inputField.acc_no);
        formData.append("ifsc", inputField.ifsc);
        formData.append("acc_holder", inputField.acc_holder);
        formData.append("id", localStorage.getItem('userid'));

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        axios.post('https://wealthmcx.com/Rest5/bank_update_api', formData, config)
            .then((res) => {
                alert(res.data.msg);
                navigate('/settings');
            })
            .catch((err) => {
                alert("Could not update bank details");
                console.error(err);
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <div className="safearea bg-soft">
            <Helmet>
                <title>Bank Details</title>
            </Helmet>

            {/* Modern Header */}
            <header className="app-header bg-primary text-white shadow-sm">
                <div className="container">
                    <div className="d-flex align-items-center py-3">
                        <Link to="/settings" className="btn btn-ghost-light me-2">
                            <i className="fa fa-arrow-left"></i>
                        </Link>
                        <h1 className="h5 mb-0">Bank Details</h1>
                    </div>
                </div>
            </header>

            <main className="container py-4 mt-5">
                <div className="card border-0 shadow-sm rounded-lg overflow-hidden">
                    <div className="card-body p-4">
                        <form onSubmit={formSubmit}>
                            <div className="form-group mb-4">
                                <label htmlFor="bank_name" className="form-label fw-medium text-muted">
                                    Bank Name
                                </label>
                                <input
                                    type="text"
                                    id="bank_name"
                                    name="bank_name"
                                    value={inputField.bank_name}
                                    onChange={handleChange}
                                    className="form-control form-control-lg border-2"
                                    placeholder="Enter bank name"
                                    required
                                />
                            </div>

                            <div className="form-group mb-4">
                                <label htmlFor="acc_holder" className="form-label fw-medium text-muted">
                                    Account Holder Name
                                </label>
                                <input
                                    type="text"
                                    id="acc_holder"
                                    name="acc_holder"
                                    value={inputField.acc_holder}
                                    onChange={handleChange}
                                    className="form-control form-control-lg border-2"
                                    placeholder="Enter account holder name"
                                    required
                                />
                            </div>

                            <div className="form-group mb-4">
                                <label htmlFor="acc_no" className="form-label fw-medium text-muted">
                                    Account Number
                                </label>
                                <input
                                    type="text"
                                    id="acc_no"
                                    name="acc_no"
                                    value={inputField.acc_no}
                                    onChange={handleChange}
                                    className="form-control form-control-lg border-2"
                                    placeholder="Enter account number"
                                    required
                                />
                            </div>

                            <div className="form-group mb-4">
                                <label htmlFor="ifsc" className="form-label fw-medium text-muted">
                                    IFSC Code
                                </label>
                                <input
                                    type="text"
                                    id="ifsc"
                                    name="ifsc"
                                    value={inputField.ifsc}
                                    onChange={handleChange}
                                    className="form-control form-control-lg border-2"
                                    placeholder="Enter IFSC code"
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary btn-sm w-100 py-3 mt-3 fw-bold"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                ) : (
                                    'Update Bank Details'
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    );
}